module.exports = __webpack_public_path__ + "img/hometop_item_imgs03.404c37c2.png";